module.exports = __webpack_public_path__ + "img/sw1-b2.7a454e3b.jpg";